<div [hidden]="isSessionActive && embed">
  <payment-contact-info
    class="font-md"
    [userInfo]="info"
    [countryCode]="countryCode"
    [personType]="personType"
    [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
    [bakeryId]="bakeryId"
    [useCompanySearcher]="useCompanySearcher"
    (onInfoUpdated)="infoUpdated($event)"
    (onValidUpdated)="isValid = $event"
    (onCompanySelected)="onCompanySelected.emit($event)"
  ></payment-contact-info>
  <div class="mt-4 pt-3 text-center">
    <button class="btn btn-pink btn-lg confirm-button" [disabled]="!isValid" (click)="submit($event)">
      {{ 'orderProcess.payment.bambora.confirm' | translate }}
    </button>

    <terms-and-conditions class="d-block mt-3" (onTermsClick)="onTermsClick.emit()">
    </terms-and-conditions>
  </div>
</div>
<div [hidden]="!isSessionActive || !embed">
  <ui-back-button class="d-block mb-4" (onClick)="cancelSession()" [showTextOnlyOnDesktop]="false"
                  [translateKey]="'orderProcess.payment.bambora.backToContactDetails'"></ui-back-button>
  <div class="embed-container" #embedContainer>
  </div>
</div>
